const MINUTES_PER_HOUR = 60;

/**
 * The date's UTC offset as `UTC±hh:mm`, or plain `UTC` when there is no offset.
 *
 * `getTimezoneOffset` reports UTC minus local, so a zone AHEAD of UTC returns a negative number
 * and has to be rendered with a `+`.
 */
export const getUTCOffset = (date: Date) => {
  const offset = Math.round(date.getTimezoneOffset());
  if (offset === 0) {
    return 'UTC';
  }

  const absOffset = Math.abs(offset);
  const hours = Math.floor(absOffset / MINUTES_PER_HOUR);
  const minutes = absOffset % MINUTES_PER_HOUR;
  const sign = offset <= 0 ? '+' : '-';
  return `UTC${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};
